import type { Task } from '@timato/shared';
import { useAuth } from '@/auth/store';
import { selectMembers, useTeam } from '@/team/store';

/** Who holds a shared task's lock, when it is someone else: a name, or null when the task is free to take. */
export function useLockHolder() {
  const me = useAuth((s) => s.user?.id);
  const members = useTeam(selectMembers);
  return (t: Task) => (t.claimedBy && t.claimedBy !== me ? members.find((m) => m.userId === t.claimedBy)?.name ?? 'a teammate' : null);
}
